import React, { useState, useImperativeHandle, useRef, forwardRef } from 'react';
import { FormGroup, Input, Select, Button, message, Icon } from '@tencent/spaui';
import './info-common.scss';
import { post } from 'store/request';

const baseState = {
  manager_name: '', // 用户名称
  manager_type: 'qq', // 账号类型
  manager_email: '', // 邮箱
  manager_qq: '', // qq
  manager_wx: '', // 微信
  manager_mobile: '', // 手机号码
  sms_verify_code: '', // 验证码
};

// const baseState = {
//   manager_name: '志哥牛逼', // 用户名称
//   manager_type: 'qq', // 账号类型
//   manager_email: '123@12.com', // 邮箱
//   manager_qq: '123123', // qq
//   manager_wx: '', // 微信
//   manager_mobile: '18514203861', // 手机号码
//   sms_verify_code: '', // 验证码
// };

const FormExamStrateg: { [key: string]: any } = {
  // 用户名称
  manager_name: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length < 2) {
      return '内容过短';
    }
    if (value.length > 20) {
      return '长度过长';
    }
    return false;
  },
  manager_email: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    if (!value.includes('@')) {
      return '请输入正确邮箱格式';
    }
    return false;
  },
  manager_wx: (value: any, formData: { manager_type: string }) => {
    if (formData.manager_type !== 'wx') {
      return false;
    }
    if (!value) {
      return '不能为空';
    }
    if (value.length > 20) {
      return '长度过长';
    }
    return false;
  },
  manager_qq: (value: any, formData: { manager_type: string }) => {
    if (formData.manager_type !== 'qq') {
      return false;
    }
    if (!value) {
      return '不能为空';
    }
    if (value.length > 20) {
      return '长度过长';
    }
    if (isNaN(+value)) {
      return '请输入正确QQ号码';
    }
    return false;
  },
  manager_mobile: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 11) {
      return '长度过长';
    }
    if (isNaN(+value)) {
      return '请输入正确手机号码';
    }
    return false;
  },
  sms_verify_code: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length !== 6) {
      return '请输入正确校验码';
    }
    if (isNaN(+value)) {
      return '请输入正确校验码';
    }
    return false;
  },
};

const Feedback = (num: number, total: number) => (
  <span>
    <span className="spaui-input-feedback-count">{num}</span>
    <span className="spaui-input-feedback-divider">/</span>
    <span className="spaui-input-feedback-range">{total}</span>
  </span>
);

interface Props {
  children?: React.FunctionComponent<{ submit: () => void }>;
  onSubmit?: (data: any) => void;
  initData?: { [key: string]: any };
}

// 基本信息
// eslint-disable-next-line react/display-name
const BaseInfo: React.FC<Props> = forwardRef((props, cref) => {
  // 表单所有数据
  const [formData, setFormData] = useState<{ [key: string]: any }>({ ...baseState, ...props.initData });
  // 表单项检查
  const [formExam, setFormExam] = useState<{ [key: string]: any }>({});

  const [verifyCodeTime, setTime] = useState(0);

  const setFormValue = (name: string, value: any) => {
    formData[name] = value;
    setFormData({ ...formData });
  };

  // 返回 true 代表表单正确
  const checkForm = (key: string): boolean => {
    const res = FormExamStrateg[key]?.(formData[key], formData);
    formExam[key] = res;
    setFormExam({ ...formExam });
    return !res;
  };

  const countDown = (time: number) => {
    setTime(time);
    if (time === 0) {
      return;
    }
    setTimeout(countDown, 1000, time - 1);
  };

  const getCode = () => {
    if (checkForm('manager_mobile') && (window as any).TencentCaptcha) {
      try {
        // 直接生成一个验证码对象
        const captcha1 = new (window as any).TencentCaptcha(
          '2075023792',
          (res: { ret: number; ticket: string; randstr: string }) => {
            if (res.ret !== 0) {
              return;
            }
            post('/tof/sms', {
              phone: formData.manager_mobile,
              ticket: res.ticket,
              randstr: res.randstr,
            }).then(() => {
              message.success('验证码发送成功');
              countDown(60);
            });
          }
        );
        captcha1.show(); // 显示验证码
      } catch (error) {
        console.log(error);
      }
    }
  };

  const submit = () => {
    const result = Object.keys(FormExamStrateg).map((item) => checkForm(item));
    if (result.includes(false)) {
      return;
    }
    props.onSubmit?.(formData);
    return formData;
  };

  const Component = props.children;

  const contentRef = useRef();
  useImperativeHandle(cref, () => ({
    submit,
  }));

  return (
    <div ref={contentRef}>
      <div className="info-content">
        <div className="form-line">
          <span className="form-label">管理员名称</span>
          <FormGroup
            className="form-item"
            error={formExam.manager_name}
            feedback={Feedback(formData.manager_name.length, 20)}
          >
            <Input
              placeholder="请输入你的姓名"
              value={formData.manager_name}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('manager_name', value.trim());
                checkForm('manager_name');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">邮箱</span>
          <FormGroup
            className="form-item"
            error={formExam.manager_email}
            // feedback={Feedback(formData['manager_email'].length, 50)}
          >
            <Input
              placeholder="请输入你的邮箱"
              value={formData.manager_email}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('manager_email', value.trim());
                checkForm('manager_email');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line" style={{ marginBottom: 0 }}>
          <span className="form-label">开户账号</span>
          <div className="form-item" style={{ display: 'flex' }}>
            <Select
              style={{ width: '100px' }}
              data={[
                { label: '微信', value: 'wx' },
                { label: 'QQ', value: 'qq' },
              ]}
              value={formData.manager_type}
              onChange={(e: EventTarget, value: string) => {
                const cleanDataHash: { [key: string]: string } = {
                  qq: 'manager_wx',
                  wx: 'manager_qq',
                };
                setFormValue(cleanDataHash[value], '');
                setFormValue('manager_type', value);
              }}
            />
            <FormGroup
              style={{ flex: 1 }}
              error={formExam[formData.manager_type === 'qq' ? 'manager_qq' : 'manager_wx']}
            >
              <Input
                placeholder=""
                value={formData.manager_type === 'qq' ? formData.manager_qq : formData.manager_wx}
                onChange={(event: EventTarget, value = '') => {
                  const keyName = formData.manager_type === 'qq' ? 'manager_qq' : 'manager_wx';
                  setFormValue(keyName, value.trim());
                  checkForm(keyName);
                }}
                underlined
              />
            </FormGroup>
          </div>
        </div>

        <div style={{ padding: '0 0 20px 120px' }}>
          <Icon
            name="exclamation-filled"
            style={{
              verticalAlign: 'text-bottom',
              color: '#296bef',
              marginRight: '8px',
            }}
          />
          <span>需准备【开户账号使用授权书】进行上传，被授权信息与开户信息请保持一致，避免影响审核进度。 </span>
          <a
            target="_blank"
            href="https://docs.qq.com/doc/DWXhsWG9RaEJtY2FW"
            style={{ color: '#0061e7' }}
            rel="noreferrer"
          >
            （【ISV模版】开户账号使用授权书模版）
          </a>
        </div>

        <div className="form-line" style={{ marginBottom: '22px' }}>
          <span className="form-label">手机号</span>
          <div className="form-item" style={{ display: 'flex' }}>
            <FormGroup style={{ flex: 1 }} error={formExam.manager_mobile}>
              <Input
                placeholder="请输入你的手机号码"
                value={formData.manager_mobile}
                onChange={(event: EventTarget, value = '') => {
                  setFormValue('manager_mobile', value.trim());
                  checkForm('manager_mobile');
                }}
                underlined
              />
            </FormGroup>
            {verifyCodeTime === 0 ? (
              <Button onClick={getCode}>获取校验码</Button>
            ) : (
              <Button disabled>重新获取({verifyCodeTime})</Button>
            )}
          </div>
        </div>
        <div className="form-line">
          <span className="form-label" />
          <FormGroup className="form-item" error={formExam.sms_verify_code}>
            <Input
              placeholder="填写校验码"
              value={formData.sms_verify_code}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('sms_verify_code', value.trim());
                checkForm('sms_verify_code');
              }}
              underlined
            />
          </FormGroup>
        </div>
      </div>
      <div style={{ display: 'inline-block' }}>{Component && <Component submit={submit} />}</div>
    </div>
  );
});

export default BaseInfo;
